import { useEffect, useRef } from 'react';

import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupContractExpiryDatePromoDisplayedOnce } from '@tracking/trackingEvents';

import { RenewalCaptureForm } from './RenewalCaptureForm';

const HomeInsurance = () => {
  const formRef = useRef<HTMLDivElement>(null);
  const isInView = useIsInView(formRef);

  const { trackingContexts } = useTrackingContext();
  const trackPromoDisplayed =
    useTrackSignupContractExpiryDatePromoDisplayedOnce();

  useEffect(() => {
    if (isInView) {
      trackPromoDisplayed(
        { product: 'HomeInsurance' },
        { contexts: trackingContexts }
      );
    }
  }, [isInView, trackPromoDisplayed, trackingContexts]);

  return (
    <RenewalCaptureForm
      field="renewalHomeInsuranceDate"
      ref={formRef}
      label="Home insurance renewal date"
    />
  );
};

export { HomeInsurance };
